export const FAVOURITES_SET_ERROR = "FAVOURITES_SET_ERROR";
export const FAVOURITES_SET_LIST = "FAVOURITES_SET_LIST";
export const FAVOURITES_SET_PREV_COUNT = "FAVOURITES_SET_PREV_COUNT";

export const setList = list => ({
    type: FAVOURITES_SET_LIST,
    payload: {
        list,
    }
});

export const setPrevCount = prevCount => ({
    type: FAVOURITES_SET_PREV_COUNT,
    payload: {
        prevCount,
    }
});

export const setError = error => ({
    type: FAVOURITES_SET_ERROR,
    payload: {
        error,
    }
});
